export default "<div\r\n  [attr.aria-expanded]=\"active\"\r\n  [attr.aria-hidden]=\"!active\"\r\n>\r\n  <ng-content></ng-content>\r\n</div>\r\n\r\n";